import { useLayoutEffect } from 'react';
import { Commentable } from '@/shared/comments/Commentable';
import { ChatShell } from '@/versions/v1/chrome/chat/ChatShell';
import { useChat } from '@/versions/v1/shared/ChatContext';

// WorkspaceChatScene — chat-first `/` (parity.P6c / D1). ai-foundation's `/`
// IS the assistant: full-width chat with the files/artifacts rail beside it.
// The docked app-shell AI rail is hidden on this route; chat owns the main panel.
//
// Spec: docs/logic/workspace/chat-rail.md (HelpAnchor on ChatShell).
export function WorkspaceChatScene() {
  const { ensureWorkspaceThread } = useChat();

  // Route owns scope — reset before paint if a project chat visit left a
  // project-scoped thread in the shared ChatContext.
  useLayoutEffect(() => {
    ensureWorkspaceThread();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Commentable name="WorkspaceChatScene">
      <ChatShell
        layout="chat-home"
        helpDoc="workspace/chat-rail"
        helpLabel="Workspace assistant"
        storageKey="mock-ui:workspace-chat-files"
      />
    </Commentable>
  );
}
